//import "babel-polyfill";

import "jcf/js/jcf";
import "jcf/js/jcf.select";
import "jcf/js/jcf.scrollable";
import "jcf/js/jcf.checkbox";
import "jcf/js/jcf.radio";
import "slick-carousel";

import { binder, fwa } from "./libs/binder";
import { constants } from "./modules/constants";
import { staticFunctions } from "./modules/static";
import { appearingAnimation } from "./modules/appearing-animation";
import { jcfHandler } from "./modules/jcf-handler";
import { headerHandler, headerScrollHandler } from "./modules/header";
import { setHeightForFirstFullScreen } from "./modules/full-screen-section-handler";
import { showLocationInfo } from "./modules/show-location-info";
import { locationsSlider } from "./modules/locations-section-slider";
import { contactsSlider } from "./modules/contacts-slider";
import { contentHandler } from "./modules/content-handler";
import { timeline } from "./modules/timeline";
import { heroIcon } from "./modules/home-hero";
import { globalSearch } from "./modules/global-search";
import { loginPopup } from "./modules/login-popup";
import { heroSlider } from "./modules/hero-slider";
import { heroScrollAnimation } from "./modules/hero-scroll-animation";
import { wpcf7Handler } from "./modules/wpcf7-handler";
import { paginationHandler } from "./modules/pagination-handler";
import { topNotification } from "./modules/top-notification";
import { tabsTop } from "./modules/tabs-top";
import { tabsLeft } from "./modules/tabs-left";
import { videoIframe } from "./modules/video";
import { jobsPinpoint } from "./modules/jobs-pinpoint";
import { sliderReviews } from "./modules/slider-reviews";
import { contactUsForm } from "./modules/contact-us-page";

binder({
    bounds: {
        "html": [constants, staticFunctions],
        ".to-appear": appearingAnimation,
        "select": jcfHandler,
        ".site-header": [headerHandler, headerScrollHandler],
        ".full-screen-section": setHeightForFirstFullScreen,
        ".locations-info": showLocationInfo,
        ".locations-section-slider": locationsSlider,
        ".contacts-slider": contactsSlider,
        ".text-section": contentHandler,
        ".timeline": timeline,
        ".hero-icon-action-box": heroIcon,
        ".global-site-search-toggler": globalSearch,
        ".login-button-wrap": loginPopup,
        ".fnc-slider": heroSlider,
        ".fnc-slide__heading-wrap": heroScrollAnimation,
        ".wpcf7-form": wpcf7Handler,
        ".scroll-to-section": paginationHandler,
        ".top-notification": topNotification,
        ".section-tabs-top": tabsTop,
        ".section-tabs-left": tabsLeft,
        ".video-section": videoIframe,
        ".jobs-pinpoint-listing": jobsPinpoint,
        ".section-reviews": sliderReviews,
        ".contact-us-content": contactUsForm,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js